import Enumerator from '../global/Enumerator';

export const filterItemTypes = ['arr', 'bool', 'num', 'str'];

export const filterItemOperatorTypes = ['btw', 'eq', 'gt', 'inc', 'lt', 'ne'];

export class FilterItemType extends Enumerator {
  static default() {
    return this.of('str');
  }
}
FilterItemType.initEnum({
  arr: {
    get title() {
      return 'List';
    }
  },
  bool: {
    get title() {
      return 'Boolean';
    }
  },
  num: {
    get title() {
      return 'Number';
    }
  },
  str: {
    get title() {
      return 'Text';
    }
  }
});

export class FilterItemOperatorType extends Enumerator {
  static default() {
    return this.of('eq');
  }
}
FilterItemOperatorType.initEnum({
  btw: {
    get title() {
      return 'Between';
    }
  },
  eq: {
    get title() {
      return 'Equal';
    }
  },
  gt: {
    get title() {
      return 'Greater than';
    }
  },
  inc: {
    get title() {
      return 'Includes';
    }
  },
  lt: {
    get title() {
      return 'Less than';
    }
  },
  ne: {
    get title() {
      return 'Not equal';
    }
  }
});

export default {
  filterItemTypes,
  filterItemOperatorTypes,
  FilterItemType,
  FilterItemOperatorType
};
